import React from 'react';

import { LabeledAvatar } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { RecentSigner } from '../../types';

export const RecentSignersFeedItem: React.FC<Props> = ({ item }) => {
	const { translate } = useI18n();

	return (
		<LabeledAvatar
			alt={item.displayName}
			name={item.displayName}
			metatext={translate('corgi.petition_gamma.petition_sign.recent_signers.signed', {
				createdAtRelativeLocalized: item.createdAtRelativeLocalized,
			})}
			size="x-small"
			src={item.photoUrl ?? undefined}
			container="inline"
		/>
	);
};

type Props = {
	item: RecentSigner;
};
